// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1QxSb","name":"Header_name__21dh9","birthday":"Header_birthday__23xpr","skeleton":"Header_skeleton__1Tw5E"};